import { Link } from "react-router-dom";
import { sections } from "../data/sections.js";
import { toTitleCase } from "../utils/typography";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <img
            className="footer-logo"
            src="/images/logos/oss-logo-white.png"
            alt="Official Store Supplies"
          />
          <p>
            Ρουχισμός, εκτυπώσεις, επίσημα προϊόντα και είδη ένδυσης για ομάδες,
            σχολεία, επιχειρήσεις και οργανισμούς.
          </p>
        </div>

        <div>
          <h3>ΚΑΤΗΓΟΡΙΕΣ</h3>
          <div className="footer-links">
            {sections.map((section) => {
              const label = section.footerTitle || toTitleCase(section.title);

              return section.path.startsWith("http") ? (
                <a key={section.id} href={section.path} target="_blank" rel="noreferrer">
                  {label}
                </a>
              ) : (
                <Link key={section.id} to={section.path}>
                  {label}
                </Link>
              );
            })}
          </div>
        </div>

        <div>
          <h3>ΕΤΑΙΡΕΙΑ</h3>
          <div className="footer-links">
            <Link to="/contact">Επικοινωνία</Link>
            <Link to="/company/payment-methods">Τρόποι Πληρωμής</Link>
            <Link to="/company/shipping-methods">Τρόποι Αποστολής</Link>
            <Link to="/company/terms">Όροι Χρήσης</Link>
            <Link to="/company/returns-cancellations">Επιστροφές & Ακυρώσεις</Link>
            <Link to="/company/privacy-gdpr">Πολιτική Απορρήτου και GDPR</Link>
          </div>
        </div>

        <div>
          <h3>ΕΠΙΚΟΙΝΩΝΙΑ</h3>
          <div className="footer-contact">
            <p>Μεγάλου Αλεξάνδρου 48, Νέα Σμύρνη, 17122</p>
            <a href="mailto:sales@cosmidis.com">sales@cosmidis.com</a>
            <a href="tel:+302112143599">2112143599</a>
            <Link to="/contact">Σελίδα επικοινωνίας</Link>
          </div>
        </div>

        <div>
          <h3>ΩΡΑΡΙΟ ΚΑΤΑΣΤΗΜΑΤΟΣ</h3>
          <div className="footer-hours">
            <p><span>Δευτέρα – Παρασκευή</span><time>10:00 – 20:00</time></p>
            <p><span>Σάββατο</span><time>10:00 – 14:00</time></p>
            <p><span>Κυριακή</span><time>Κλειστά</time></p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Official Store Supplies</span>
        <span>Επίσημος ρουχισμός, merchandise και προσαρμοσμένες λύσεις ένδυσης.</span>
      </div>
    </footer>
  );
}
